module.exports = __webpack_public_path__ + "gb-wls.d67608c4a9127c21bc72.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/1x1/gb-wls.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/1x1/gb-wls.svg
// module chunks = styles